// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useWarehouseByLocation(location_id: string) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (!location_id) {
      setData([])
      return
    }

    setLoading(true)

    api.get("/location-warehouse/by-location", {
      params: { location_id: parseInt(location_id) }
    }).then((res: SuccessFetch<{
      payload: {
        location_warehouse_id: number
        warehouse_name: string
      }[]
    }>) => {
      setData(
        res.data.payload.map(item => ({
          label: item.warehouse_name,
          value: item.location_warehouse_id.toString()
        }))
      )
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(false)
    }

    // eslint-disable-next-line
  }, [location_id])

  return { data, isLoading }
}
